<template>
  <div class="card border-inside">
    <div v-if="$i18n.locale === 'th'" class="card-content info-list">
      <div class="content th">
        <p>
          <span class="has-text-weight-normal">Product information:</span>
          แสดงข้อมูลเบื้องต้นของผลิตภัณฑ์ในส่วนนี้จะแสดงทั้งหมด 3 หัวข้อ
        </p>
        <hr />
        <p>
          <span class="has-text-weight-normal">Product name:</span>
          แสดงชื่อสินค้าหรือผลิตภัณฑ์
        </p>
        <hr />
        <p>
          <span class="has-text-weight-normal">Website of product:</span>
          เว็บไซต์ของสินค้าหรือผลิตภัณฑ์
        </p>
        <hr />
        <p>
          <span class="has-text-weight-normal">Level of product: </span
          >แสดงระดับของผลิตภัณฑ์ว่าอยู่ในระดับไหน ระดับของผลิตภัณฑ์นั้น
          จะมีอยู่ทั้งหมด 3 ประเภท
          ซึ่งแต่ละประเภทจะมีระดับของผลิตภัณฑ์แตกต่างกันไป
        </p>
        <ol>
          <li>
            <span class="has-text-weight-normal">ระดับของผลิตภัณฑ์: </span
            >มีระดับทั้งหมดดังนี้
            <ul>
              <li>มีแนวคิดผลิตภัณฑ์หรือบริการ</li>
              <li>MVP (มีผลิตภัณฑ์เพื่อทดสอบแนวความคิดเบื้องต้นแล้ว)</li>
              <li>
                Develop (อยู่ระหว่างการพัฒนาผลิตภัณฑ์ต้นแบบ พร้อมเข้าสู่ตลาด)
              </li>
              <li>Prototype (มีผลิตภัณฑ์ต้นแบบแล้ว)</li>
              <li>Product (ผลิตภัณฑ์แล้ว พร้อมขาย)</li>
              <li>
                Traction
                (ข้อมูลบ่งบอกถึงจำนวนความต้องการของผลิตภัณฑ์หรือบริการจริง)
              </li>
            </ul>
          </li>
          <li>
            <span class="has-text-weight-normal">ระดับของธุรกิจ: </span
            >มีระดับทั้งหมดดังนี้
            <ul>
              <li>Ideation (มีแนวคิดไอเดีย)</li>
              <li>Concepting (มีผลิตภัณฑ์ต้นแบบแล้ว)</li>
              <li>Commitment (มีการทำข้อตกลงร่วมกับคู่ค้าทางธุรกิจแล้ว)</li>
              <li>Validating (ผลิตภัณฑ์หรือบริการมีการทดสอบกับลูกค้าแล้ว)</li>
              <li>Scaling (ขยายตลาด)</li>
            </ul>
          </li>
          <li>
            <span class="has-text-weight-normal">ระดับของเทคโนโลยี: </span
            >มีระดับทั้งหมดดังนี้
            <ul>
              <li>
                Basic principles observed and reported
                (การศึกษาค้นพบและข้อสังเกตพื้นฐาน)
              </li>
              <li>
                Technology concept and/or application formulated
                (การสร้างแนวคิดทางเทคโนโลยี และ/หรือ
                การประยุกต์สูตรทางเทคโนโลยี)
              </li>
              <li>
                Analytical and experimentally critical function and/or
                characteristic proof of concept (การวิเคราะห์และทดลองหน้าที่หลัก
                และ/หรือ การพิสูจน์องค์ประกอบของแนวคิด)
              </li>
              <li>
                Component and/or breadboard validation in laboratory environment
                (การตรวจสอบองค์ประกอบ และ/หรืออุปกรณ์ที่ใช้ทดลอง (breadboard)
                ในระดับห้องปฏิบัติการ)
              </li>
              <li>
                Component and/or breadboard validation in relevant environments
                (การทดสอบองค์ประกอบ และ/หรืออุปกรณ์ที่ใช้ทดลอง (breadboard)
                ในสถานการณ์ที่เกี่ยวข้อง)
              </li>
              <li>
                System/subsystem model or prototype demonstration in a relevant
                environments (การทดลองโมเดลของระบบหลักและระบบย่อย
                หรือต้นแบบในสถานการณ์ที่เกี่ยวข้อง)
              </li>
              <li>
                System prototype demonstration in an operational environment
                (การทดลองต้นแบบในภาคสนาม)
              </li>
              <li>
                Actual system completed and qualified through test and
                demonstration (ระบบจริงที่มีความสมบูรณ์ มีคุณภาพ
                และผ่านการทดสอบและทดลองแล้ว)
              </li>
              <li>
                Actual system proven through successful mission operations
                (ผลงานที่พร้อมส่งมอบและสามารถนําไปใช้งานได้จริง
                โดยผ่านการพิสูจน์เรียบร้อยแล้ว)
              </li>
            </ul>
          </li>
        </ol>
        <hr />
        <p>
          <span class="has-text-weight-normal">Industry:</span>
          แสดงประเภทของผลิตภัณฑ์ของ Company (ผู้ประกอบการ) ว่าอยู่ในประเภทไหน
          ซึ่งประเภทของผลิตภัณฑ์จะมีทั้งหมดดังนี้
        </p>
        <ul>
          <li>Food (การแปรรูปอาหาร)</li>
          <li>Smart Electronics (อิเล็กทรอนิกส์อัจฉริยะ)</li>
          <li>Digital (ดิจิทอล)</li>
          <li>
            Information & Communication Technology
            (เทคโนโลยีสารสนเทศและการสื่อสาร)
          </li>
          <li>Commerce (พาณิชย์หรือธุรกิจบริการออนไลน์)</li>
          <li>Business-to-business (ธุรกิจเพื่อผู้ประกอบธุรกิจ)</li>
          <li>Innovative Products (ผลิตภัณฑ์ที่ใช้นวัตกรรมเป็นจุดขาย)</li>
          <li>Robotics (หุ่นยนต์)</li>
          <li>
            Industrial Materials & Machine (วัสดุอุตสาหกรรมและเครื่องจักร)
          </li>
          <li>Construction Materials (วัสดุก่อสร้าง)</li>
          <li>Construction Services (บริการรับเหมาก่อสร้าง)</li>
          <li>Lifestyle Products (ของใช้ในครัวเรือน หัตถกรรม และสำนักงาน)</li>
          <li>Fashion (แฟชั่น สิ่งทอ เครื่องนุ่งห่ม)</li>
          <li>Gem and Jewelry (อัญมณีและเครื่องประดับ)</li>
          <li>Design Services (รับจ้างออกแบบ)</li>
          <li>Packaging (บรรจุภัณฑ์)</li>
          <li>Media & Publishing (สื่อและสิ่งพิมพ์)</li>
          <li>Next – Generation Automotive (ยานยนต์สมัยใหม่)</li>
          <li>Aviation and Logistics (การบินและโลจิสติกส์)</li>
          <li>Biofuels and Biochemicals (เชื้อเพลิงชีวภาพและเคมีชีวภาพ)</li>
          <li>
            Affluent, Medical and Wellness Tourism
            (การท่องเที่ยวกลุ่มรายได้ดีและการท่องเที่ยวเชิงสุขภาพ)
          </li>
          <li>Agriculture and Biotechnology (การเกษตรและเทคโนโลยีชีวภาพ)</li>
          <li>Rubber Innovation (นวัตกรรมยางพารา)</li>
          <li>Medical Hub (การแพทย์ครบวงจร)</li>
          <li>Cosmetics (ธุรกิจเครื่องสำอาง)</li>
          <li>Consultant (ที่ปรึกษา)</li>
          <li>Finance & Securities (เงินทุนและหลักทรัพย์)</li>
          <li>Insurance (ประกันภัยและประกันชีวิต)</li>
          <li>Property Development (พัฒนาอสังหาริมทรัพย์)</li>
          <li>Education (การศึกษา)</li>
          <li>Mining (เหมืองแร่)</li>
          <li>Other (ด้านอื่น ๆ)</li>
        </ul>
        <hr />
        <p>
          <span class="has-text-weight-normal">Contract date/Joined date: </span
          >แสดงวันที่ได้เซ็นสัญญาเข้าร่วมโครงการของผลิตภัณฑ์นั้น
        </p>
      </div>
    </div>
    <div v-else class="card-content info-list">
      <div class="content th">
        <p>
          <span class="has-text-weight-normal">Product information:</span>
          Show basic information of the product in this section will display all
          3 topics.
        </p>
        <hr />
        <p>
          <span class="has-text-weight-normal">Product name:</span>
          Show the name of the product or product.
        </p>
        <hr />
        <p>
          <span class="has-text-weight-normal">Website of product:</span>
          Product or product website
        </p>
        <hr />
        <p>
          <span class="has-text-weight-normal">Level of product: </span>Shows
          what level the product is at. level of that product There will be a
          total of 3 types. Each category will have different levels of
          products.
        </p>
        <ol>
          <li>
            <span class="has-text-weight-normal">Level of product: </span>There
            are the following
            <ul>
              <li>
                Product/Service Concept: The idea for the product or service.
              </li>
              <li>
                MVP (Minimum Viable Product): The product has been developed to
                test the initial concept.
              </li>
              <li>
                Develop: The product is in the process of being developed as a
                prototype and preparing for market entry.
              </li>
              <li>Prototype: A prototype of the product has been created.</li>
              <li>
                Product: The product has been manufactured and is ready for
                sale.
              </li>
              <li>
                Traction: Data indicates the actual demand for the product or
                service.
              </li>
            </ul>
          </li>
          <li>
            <span class="has-text-weight-normal">Levels of business: </span
            >There are the following
            <ul>
              <li>
                Ideation: The stage where ideas and concepts are generated.
              </li>
              <li>
                Concepting: The stage where the initial product or service
                prototypes are developed.
              </li>
              <li>
                Commitment: The stage where agreements and partnerships with
                business counterparts are established.
              </li>
              <li>
                Validating: The stage where the product or service is tested and
                validated with customers.
              </li>
              <li>
                Scaling: The stage where the business expands its market
                presence and operations.
              </li>
            </ul>
          </li>
          <li>
            <span class="has-text-weight-normal">Levels of technology: </span
            >There are the following
            <ul>
              <li>
                Basic principles observed and reported: The stage where
                fundamental principles and observations are studied and
                documented.
              </li>
              <li>
                Technology concept and/or application formulated: The stage
                where technology concepts and/or applications are developed.
              </li>
              <li>
                Analytical and experimentally critical function and/or
                characteristic proof of concept: The stage where critical
                functions and/or characteristics of the technology are analyzed,
                experimented with, and conceptually proven.
              </li>
              <li>
                Component and/or breadboard validation in laboratory
                environment: The stage where components and/or breadboard models
                are validated in a controlled laboratory setting.
              </li>
              <li>
                Component and/or breadboard validation in relevant environments:
                The stage where components and/or breadboard models are tested
                and validated in environments relevant to their intended
                application.
              </li>
              <li>
                System/subsystem model or prototype demonstration in relevant
                environments: The stage where system/subsystem models or
                prototypes are demonstrated in environments that closely
                resemble their intended real-world application.
              </li>
              <li>
                System prototype demonstration in an operational environment:
                The stage where system prototypes are demonstrated and tested in
                real operational environments.
              </li>
              <li>
                Actual system completed and qualified through test and
                demonstration: The stage where the actual system is fully
                completed, tested, and qualified through comprehensive testing
                and demonstration.
              </li>
              <li>
                Actual system proven through successful mission operations: The
                stage where the actual system has been successfully deployed and
                proven through operational missions.
              </li>
            </ul>
          </li>
        </ol>
        <hr />
        <p>
          <span class="has-text-weight-normal">Industry:</span>
          Shows the type of products of the Company (operators) that are in
          which category. The types of products are all as follows.
        </p>
        <ul>
          <li>Food</li>
          <li>Smart Electronics</li>
          <li>Digital</li>
          <li>Information & Communication Technology</li>
          <li>Commerce</li>
          <li>Business-to-business</li>
          <li>Innovative Products</li>
          <li>Robotics</li>
          <li>Industrial Materials & Machine</li>
          <li>Construction Materials</li>
          <li>Construction Services</li>
          <li>Lifestyle Products</li>
          <li>Fashion</li>
          <li>Gem and Jewelry</li>
          <li>Design Services</li>
          <li>Packaging</li>
          <li>Media & Publishing</li>
          <li>Next – Generation Automotive</li>
          <li>Aviation and Logistics</li>
          <li>Biofuels and Biochemicals</li>
          <li>Affluent, Medical and Wellness Tourism</li>
          <li>Agriculture and Biotechnology</li>
          <li>Rubber Innovation</li>
          <li>Medical Hub</li>
          <li>Cosmetics</li>
          <li>Consultant</li>
          <li>Finance & Securities</li>
          <li>Insurance</li>
          <li>Property Development</li>
          <li>Education</li>
          <li>Mining</li>
          <li>Other</li>
        </ul>
        <hr />
        <p>
          <span class="has-text-weight-normal">Contract date/Joined date: </span
          >Shows the date that the product was signed into the program.
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>